import type { AssetCommodity } from '@/entities/asset'

export const getPrimaryCommodity = (commodities: readonly AssetCommodity[]): string | undefined => {
  return commodities?.find(commodity => commodity.primary)?.commodity?.name
}

export const getCommodityByproducts = (commodities: readonly AssetCommodity[]): string[] => {
  return commodities
    ?.filter(c => !c.primary)
    .map(c => c.commodity?.name)
    .sort((a, b) => {
      const [a_, b_] = [a, b].map(c => c.toUpperCase())
      return a_ > b_ ? 1 : a_ < b_ ? -1 : 0
    })
}

export const getPercentOwnership = (decimalOwnershipValue: number): string => `${+(decimalOwnershipValue * 100).toFixed(2)}%`

export const formatNumber = (n: number): string => n.toLocaleString(undefined, { maximumFractionDigits: 0 })

export const formatMoney = (n: number): string => {
  const formatter = Intl.NumberFormat('en', { notation: 'compact' })
  return formatter.format(n)
}
